import { render } from "./CustomAreaManagerUpsert.vue?vue&type=template&id=613a8835&scoped=true"
import script from "./CustomAreaManagerUpsert.vue?vue&type=script&lang=js"
export * from "./CustomAreaManagerUpsert.vue?vue&type=script&lang=js"

import "./CustomAreaManagerUpsert.vue?vue&type=style&index=0&id=613a8835&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-613a8835"]])

export default __exports__